/**
 * @module app.ext.cwqi
 */

import { autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { CwqiManager, CwqiSavedEvent, CwqiChangedEvent, CwqiReloadedGuidelinesEvent } from 'app/ext/cwqi/cwqi-manager';
import { EssModalCustomElement } from 'app/shared/elements/ess-dialog';
import { AuthPageContext } from 'app/um/lib/auth-page-context';
import { Subscription, EventAggregator } from 'aurelia-event-aggregator';
import { SaveCwqi } from 'app/ext/cwqi/save-cwqi';
import * as UM from 'app/um/models/essette-api';
import * as MCG from 'app/mcg/models/essette-api';


@autoinject()
export class CwqiModalCustomElement {

    ////****************** Fields and Properties ************************************////
    @bindable
    protected auth: UM.Auth | null = null;

    private guidelines: MCG.CwqiEpisodeGuideline[] = [];
    private eventSubscriptions: Array<Subscription> = [];

    ////****************** Element References ***************************************////
    protected $modalSave!: EssModalCustomElement;
    protected $saveCwqi!: SaveCwqi;


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        protected readonly cwqi: CwqiManager,
        private readonly events: EventAggregator,
        private readonly context: AuthPageContext) {
    }

    protected bind(): void {
        if(!this.auth) { this.auth = this.context.auth; }
        this.reloadGuidelines();

        this.eventSubscriptions.push(
            this.events.subscribe(CwqiChangedEvent, () => { this.cwqiChange() }),
            this.events.subscribe(CwqiSavedEvent, () => { this.cwqiSave() }),
            this.events.subscribe(CwqiReloadedGuidelinesEvent, () => { this.reloadGuidelines() })
        );
    }

    protected unbind() {
        this.eventSubscriptions.forEach((s) => s.dispose());
        this.eventSubscriptions = [];
    }

    ////****************** Events ***************************************************////
    public async cwqiChange(): Promise<void> {
        if(this.$modalSave) {

            const summary = await this.getSummary();
            const showModal = await this.$saveCwqi.loadSummary(summary)
            if(showModal) {
                this.$modalSave.open();
            }
            else {
                this.$modalSave.close();
            }
        }
    }

    public async cwqiSave(): Promise<void> {
        if(this.$modalSave) {
            this.$modalSave.close();
        }
    }


    ////****************** Functions ************************************************////
    private async getSummary(): Promise<string | null> {
        if(!this.auth) { return null; }

        const response = await this.cwqi.getSummary(this.auth, false);
        return response.resultText;
    }

    private reloadGuidelines(): void {
        this.guidelines = this.context.cwqiEpisodeGuidelines;
    }

    ////****************** Service Calls ********************************************////

}
